



















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { currencyFormat } from '@/utils/helpers';
import { PayloadState } from '@/types/types';

@Component({
  name: 'AutocreditAuthorizeDialog',
  filters: {
    currencyFormat,
  },
})
export default class AutocreditAuthorizeDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true, default: 'selected' }) mode!: 'selected' | 'day';
  @Prop({ required: true, default: 0 }) count!: number;
  @Prop({ default: 0 }) totalAmount!: number;
  @Prop({ default: () => [] }) businessDates!: string[];
  @Prop({ default: '' }) authorizedBy!: string;

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('authorize')
  confirm() {
    return true;
  }
}
